import i18n from '@/i18n'
import { _plus, _times, _percentage, _minus, _toFixed } from '@/helpers/bigNumber'

export const type = state => (key) => {
  let taxType = state._[key].type
  let code = taxType.split('#')[0]
  if (['8', '2', '7'].includes(code)) taxType = `${code}#0`
  return taxType
}

export const percent = state => (key) => {
  let tax = state._[key]
  return tax.percent
}

export const specialCode = state => (key) => {
  return state._[key].specialCode
}

export const specialReason = state => (key) => {
  return state._[key].specialReason
}

export const isEditable = state => (key) => {
  let code = state._[key].type.split('#')[0]
  return ['2#0', '7#0'].includes(state._[key].type) || code === '8'
}

export const isIVA0 = state => (key) => {
  return state._[key].type === '1#0.0' || state._[key].type === '3#0.0'
}

export const isIRPF = state => (key) => {
  return state._[key].type.split('#')[0] === '8'
}

export const base = state => {
  return state.base
}

export const amount = state => (key, discount = 0, globalDiscount = 0) => {
  let _brutto = _plus(_times(state.base, discount), state.base)
  _brutto = _plus(_times(_brutto, globalDiscount), _brutto)
  const raw = _times(_brutto, _percentage(state._[key].percent))
  const result = _toFixed(raw, 2)
  return result
}

export const formatAmount = (state, getters) => (key) => {
  return i18n.n(getters.amount(key), 'currency')
}

export const getList = state => {
  return state.list
}

export const total = (state, getters) => (discount = 0, globalDiscount = 0) => {
  const result = _toFixed(state.list.reduce((acc, k) => {
    // 70621 El total de impuestos por línea solo tiene sentido en el resumen ya que debe contemplar los descuentos globales
    const amount = getters['amount'](k, discount, globalDiscount)
    const acumulado = getters['isIRPF'](k) ? _minus(acc, amount) : _plus(acc, amount)
    return acumulado
  }, 0), 2)
  return result
}

export const totalPercent = (state, getters) => {
  return state.list.reduce((acc, k) => {
    return getters['isIRPF'](k)
            ? _minus(acc, Number(getters.percent(k)))
            : _plus(acc, Number(getters.percent(k)))
  }, 0)
}

export const apificate = (state, getters) => {
  return state.list.map(k => {
    let tax = Object.assign({}, state._[k])
    tax.base = _toFixed(getters['base'], 2)
    return tax
  })
}
